<template>
    <div class="rc">
      <div ref="cmain1" class="cmain" @mouseover="autoTimePaused = true" @mouseout="autoTimePaused = false"></div>
    </div>
  </template>

<script>
import * as methods from './method.js'
export default {
    name: 'template.scope5',
	props: {
		vdata: {
			type: [Array, String],
			default: () => []
		},
		jsondata: {
			type: [Array, String],
			default: () => []
		},
		scopedata: {
			type: Object,
			default: () => {}
		}
	},
    data() {
        return {
            timer: null,
            defaultdata: [
                { value1: '名称一', value2: '1130', value3: '万元' },
                { value1: '名称二', value2: '760' },
                { value1: '名称三', value2: '720' },
                { value1: '名称四', value2: '900' },
                { value1: '名称五', value2: '430' },
            ],
            valueMap: [
                { name: '名称', key: "value1" },
                { name: '数值', key: "value2" },
                { name: '单位', key: "value3" },
            ],
            chartdata: [],
            exceldata: [],
			apiconfig: {},
			isApi: false,
			scope: {},
            autoTimePaused: false, // 新增变量，用于标记定时器是否暂停
        }
    },
    beforeDestroy() {
        this.timer = null
        clearInterval(this.timer);
    },
    watch: {
		vdata(n) {
			if(n && n.length) {
				let vdatalist = n.filter(item => {
                    let vlist = Object.keys(item)
                    let isdata = false
                    vlist.forEach(del => {
                        if (item[del] == undefined) {
                            item[del] = ''
                        } else if (del && item[del]) {
                            isdata = true
                        }
                    })
                    if (vlist.length && isdata) return item
                })
                this.defaultdata = vdatalist
			}
		},
		jsondata(n) {
			this.exceldata = n
		},
        defaultdata(n) {
            this.setdata()
        }
    },
    methods: {
		...methods,
        setdata() {
            const vdata = JSON.parse(JSON.stringify(this.defaultdata))
            this.chartdata = vdata.sort((a, b) => +b.value2 - +a.value2)
            this.chartdata = this.chartdata.filter(item => item && item.value1)
            this.$nextTick(() => {
                this.cDrawCircle(); //需要刷新的数据
            });
        },
        cDrawCircle() {
            clearInterval(this.timer)
            this.timer = null
            var echarts = require('echarts');
            var TmyChart = echarts.init(this.$refs.cmain1);
            let yValue = this.chartdata.map(item => {
                return item.value1
            })
            let xValue = this.chartdata.map(item => {
                return +item.value2
            })
            let unit = this.chartdata[0].value3 || ''
            var Toption = {
                color: ['#d84430'],
                tooltip: {
                    show: true
                },
                grid: {
                    top: '3%',
                    bottom: '0%',
                    left: '10px',
                    right: '5%'
                    // containLabel: false
                },
                xAxis: {
                    nameTextStyle: {
                        color: 'rgba(255, 255, 255, 0.8)',
                        align: 'right'
                    },
                    splitLine: {
                        show: false,
                    },
                    axisLine: {
                        show: false,
                    },
                    axisLabel: {
                        color: 'rgba(255, 255, 255, 0.8)'
                    },
                },
                yAxis: [
                    {
                        type: "category",
                        //升序
                        inverse: true,
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        max: 4,// only the largest 3 bars will be displayed
                        axisLabel: {
                            show: true,
                            inside: true,
                            // margin: -5,
                            align: "left",
                            // overflow: "truncate",
                            verticalAlign: 'bottom',
                            lineHeight: 40,
                            color: '#A1A4AC',
                            fontSize: 14,
                            width: 300,
                            overflow: 'truncate',
                            formatter: function (value, index) {   // 设置y轴文字拼接
                                return value ? ('TOP. ' + (index + 1) + "    " + value) : ''
                            },
                        },
                        data: yValue,
                    },
                ],
                series: [
                    {
                        itemStyle: {
                            emphasis: {
                                barBorderRadius: [5, 5, 5, 5],
                            },
                            normal: {

                                barBorderRadius: [5, 5, 5, 5],
                                label: {
                                    show: false, //开启显示
                                },
                                color: new echarts.graphic.LinearGradient(0, 0, 1, 1, [{
                                    offset: 0,
                                    color: "#0C3F69 " // 0% 处的颜色 
                                }, {
                                    offset: 0.6,
                                    color: "#0A72FC" // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: "#0A72FC" // 100% 处的颜色
                                }], false)
                            },
                        },
                        type: "bar",
                        barWidth: 10,
                        backgroundStyle: {
                            color: '#1F2A30', // 背景条的颜色
                            barBorderRadius: [5, 5, 5, 5],
                        }, label: {
                            position: [10, 10], //在右显示
                            normal: {
                                align: 'right',
                                position: [410, -20],
                                show: true,
                                textStyle: {
                                    color: '#FAEC00',
                                    fontSize: 14,
                                },
                                formatter: '{c}' + unit
                            },
                        },
                        showBackground: true, // 【主要代码】
                        data: xValue,
                    }]

            };
            TmyChart.clear();
            Toption && TmyChart.setOption(Toption);
            this.timer = setInterval(() => {
                if (this.autoTimePaused) return; // 如果定时器暂停，则不执行后续逻辑
                TmyChart.clear();
                Toption && TmyChart.setOption(Toption);
            }, 5000);
        },
    },
	mounted() {
		if (this.vdata && this.vdata.length) {
			this.defaultdata = this.vdata
		}
		if (this.jsondata && this.jsondata.length) {
			this.exceldata = this.jsondata
		}
        this.setData()
        this.setdata()
	},
};
</script>

<style scoped lang="scss">
.rc {
  width: 435px;
  height: 240px;
  padding: 10px 0;
  display: flex;
  position: relative;
  overflow: hidden;
}

.cmain {
  width: 100%;
  height: 100%;
}
</style>